import { setBackdropState } from "../helpers/util";
import { CookieType, CurrencyValues } from "../helpers/enums";
import { setCookieTypeAndValue } from "../helpers/util";

export const currencyOverlay = () => {
  const root = document.querySelector(
    "[js-currency-overlay-backdrop]"
  ) as HTMLElement;
  if (root) {
    const overlayCloseCta = root.querySelector("[js-currency-overlay-close]");
    const overlayCofirm = root.querySelector("[js-currency-overlay-confirm]");
    if (overlayCloseCta) {
      overlayCloseCta.addEventListener("click", () => {
        setBackdropState(root, false);
      });
    }
    if (overlayCofirm) {
      overlayCofirm.addEventListener("click", () => {
        const selectElement = document.getElementById(
          "currency-overlay-native"
        ) as HTMLSelectElement;

        const value = selectElement.value;

        if (selectElement && value) {
          setCookieTypeAndValue(CookieType.CURRENCY, value.toLowerCase());

          if (value === CurrencyValues.GBP) {
            setCookieTypeAndValue(CookieType.COUNTRY, "gb");
          } else if (value === CurrencyValues.USD) {
            setCookieTypeAndValue(CookieType.COUNTRY, "us");
          } else {
            setCookieTypeAndValue(CookieType.COUNTRY, "ie");
          }

          window.location.reload();
        }
      });
    }
  }
};
